module.exports = __webpack_public_path__ + "static/media/loop_family.c3815cf8.jpg";